;(function($) {
    // require ("../../vendor/animateNumber/jquery.animateNumber.min.js");

    let $indicators = $(".js-indicators");
    if (!$indicators.length) return;
    var indicatorsTop = $indicators.offset().top;
    // console.log("indicators top: " + indicatorsTop);
    var isAnimated = false;
    


    var windowHeight = window.innerHeight;
    $(window).resize(function() {
        windowHeight = window.innerHeight;        
    });

    if (($(this).scrollTop() + windowHeight / 3 * 2) > indicatorsTop) {
        console.log("bingo!");
        runAnimation();
    }

    $(window).scroll(function() {

        // console.log("window.scrollTop(): " + $(this).scrollTop());
        if (($(this).scrollTop() + windowHeight - 100) > indicatorsTop) {
            //sconsole.log("bingo!");
            runAnimation();
        }
    });

    var separator = $.animateNumber.numberStepFactories.separator(' ')
        //indicators__amount-large
        // var number = $(".indicators__amount-large").data("number");
        // number = parseInt(number.replace(/\s/g, ""));
        // var delay = $(".indicators__amount-large").data("delay")

    function runAnimation() {
        if (isAnimated) return;
        isAnimated = true;
        var $animatedElements = $(".js-indicators__animation");

        for (var i = 0; i < $animatedElements.length; i++) {

            (function(i) {
                var $element = $($animatedElements[i]);
                var number = $element.data("number");
                var delay = $element.data("delay");

                setTimeout(function() {
                    $element.animateNumber({
                        number: number,
                        numberStep: separator
                    }, 1000)
                }, delay);
            })(i);
        }
    }
})(jQuery);



// WEBPACK FOOTER //
// ./common.blocks/indicators/indicators.js